import { TicketCard } from './TicketCard'
import type { TicketListItem } from '../services/api'

interface KanbanColumnProps {
  label: string
  tickets: TicketListItem[]
  projectSlug: string
}

export function KanbanColumn({ label, tickets, projectSlug }: KanbanColumnProps) {
  return (
    <div className="flex-1 min-w-[250px]">
      <div className="flex items-center gap-2 mb-3">
        <h3 className="text-sm font-semibold text-gray-700">{label}</h3>
        <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">
          {tickets.length}
        </span>
      </div>
      <div className="space-y-2">
        {tickets.map((ticket) => (
          <TicketCard key={ticket.id} ticket={ticket} projectSlug={projectSlug} compact />
        ))}
        {tickets.length === 0 && (
          <div className="border border-dashed border-gray-200 rounded-lg p-4 text-center text-xs text-gray-400">
            No items
          </div>
        )}
      </div>
    </div>
  )
}
